import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * Scrolls the window back to the top whenever the route changes.
 * Renders nothing.
 */
export function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [pathname]);
  return null;
}